<template>
  <v-dialog :value="dialog" @input="$emit('update:dialog', $event)" max-width="600px">
    <v-card v-if="warning">
      <v-card-title>
        <span class="headline">Detalles de Amonestación</span>
        <v-spacer></v-spacer>
        <v-icon @click="closeDialog" class="cursor-pointer">mdi-close</v-icon>
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12">
            <div class="subtitle-2 font-weight-bold grey--text">Jugador</div>
            <div class="headline">{{ warning.player }}</div>
            <div class="caption grey--text">ID: {{ warning.player_id }} | Grupo {{ warning.group }}</div>
          </v-col>
        </v-row>

        <v-divider class="my-4"></v-divider>

        <v-row>
          <v-col cols="6">
            <div class="subtitle-2 font-weight-bold grey--text">Amonestación</div>
            <div class="headline">{{ warning.warning_type }}</div>
          </v-col>
          <v-col cols="6">
            <div class="subtitle-2 font-weight-bold grey--text">Strikes Aplicados</div>
            <div class="display-1">
              <v-icon large :color="getStrikesColor(warning.strikes)">mdi-alert-circle</v-icon>
              <span :class="`${getStrikesColor(warning.strikes)}--text`">{{ warning.strikes }}</span>
            </div>
          </v-col>
        </v-row>

        <v-divider class="my-4"></v-divider>

        <v-row>
          <v-col cols="6">
            <div class="subtitle-2 font-weight-bold grey--text">Fecha</div>
            <div>{{ formatDate(warning.date) }}</div>
          </v-col>
          <v-col cols="6">
            <div class="subtitle-2 font-weight-bold grey--text">Hora</div>
            <div>{{ warning.time }}</div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <div class="subtitle-2 font-weight-bold grey--text">Categoría</div>
            <v-chip small :color="getCategoryColor(warning.category)">
              {{ getCategoryLabel(warning.category) }}
            </v-chip>
          </v-col>
        </v-row>

        <v-divider class="my-4"></v-divider>

        <v-row v-if="warning.notes">
          <v-col cols="12">
            <div class="subtitle-2 font-weight-bold grey--text">Notas</div>
            <div class="pa-3 grey lighten-4 rounded">
              {{ warning.notes }}
            </div>
          </v-col>
        </v-row>

        <v-row class="mt-4">
          <v-col cols="12">
            <v-alert type="info" outlined>
              <div class="caption font-weight-bold">Información</div>
              <div class="caption mt-1">
                Esta amonestación ha sido registrada en el expediente del jugador.
                Los strikes se acumulan y al alcanzar 3 el jugador será bloqueado para futuras reservas.
              </div>
            </v-alert>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="closeDialog">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'WarningDetailDialog',
  props: {
    dialog: Boolean,
    warning: Object
  },
  methods: {
    closeDialog () {
      this.$emit('update:dialog', false)
    },
    formatDate (dateStr) {
      const date = new Date(dateStr)
      return date.toLocaleDateString('es-MX', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    },
    getCategoryColor (category) {
      const colors = {
        pace: 'orange',
        damage: 'red',
        attire: 'blue',
        conduct: 'red',
        rules: 'purple',
        warning: 'grey'
      }
      return colors[category] || 'grey'
    },
    getCategoryLabel (category) {
      const labels = {
        pace: 'Ritmo de Juego',
        damage: 'Daño al Campo',
        attire: 'Código de Vestimenta',
        conduct: 'Conducta',
        rules: 'Reglas de Juego',
        warning: 'Advertencia'
      }
      return labels[category] || 'Otro'
    },
    getStrikesColor (strikes) {
      if (strikes >= 2) return 'red'
      if (strikes >= 1) return 'orange'
      return 'grey'
    }
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
